__turbopack_context__.v({
  "button": "inputWithButton-module__oPH7QW__button",
  "buttonSize__Medium": "inputWithButton-module__oPH7QW__buttonSize__Medium",
  "buttonSize__Small": "inputWithButton-module__oPH7QW__buttonSize__Small",
  "inputColor__darkBlue": "inputWithButton-module__oPH7QW__inputColor__darkBlue",
  "inputColor__transparent": "inputWithButton-module__oPH7QW__inputColor__transparent",
  "inputColor__white": "inputWithButton-module__oPH7QW__inputColor__white",
  "inputWithbutton": "inputWithButton-module__oPH7QW__inputWithbutton",
  "styles2026": "inputWithButton-module__oPH7QW__styles2026",
});
